import multiform from "../components/images/multiform.png";
import urlshortner from "../components/images/urlshortner.png";
import phoneflag from "../components/images/phoneflag.png";
import resumeGen from "../components/images/resumeGen.png";

import pythonL from "../components/assets/icons8-python.svg";
import csharpL from "../components/assets/icons8-c-sharp-logo.svg";
import reactL from "../components/assets/icons8-react.svg";
import djangoL from "../components/assets/django-svgrepo-com.svg";
import tailwindL from "../components/assets/icons8-tailwind-css.svg";
import javaScriptL from "../components/assets/js-svgrepo-com.svg";
import chakraL from "../components/assets/icons8-chakra-ui.svg";
import NodeL from "../components/assets/icons8-nodejs.svg";

import Inkmark from "../components/images/Inkmark.png";
import Miradom from "../components/images/Miradom.png";

export const skill = [
  {
    img: pythonL,
    name: "Python",
  },
  {
    img: csharpL,
    name: "C Sharp",
  },
  {
    img: reactL,
    name: "React",
  },

  {
    img: djangoL,
    name: "Django",
  },
  {
    img: tailwindL,
    name: "Tailwind CSS",
  },

  {
    img: javaScriptL,
    name: "JavaScript",
  },
  {
    img: chakraL,
    name: "Chakra",
  },
  {
    img: NodeL,
    name: "NodeJs",
  },
];

export const project = [
  {
    img: resumeGen,
    title: "AI Resume Generator",
    body: "Developed an AI-powered resume generator that converts user input into professional, ATS-friendly resumes with dynamic templates and optimized formatting for various industries.",
    skill: "React | Next.js | TailwindCSS | Django | Python | OpenAI API",
    link: "https://www.airesume-gen.com/",
  },
  {
    img: Inkmark,
    title: "Inkmark",
    body: "As a Full Stack Developer on the InkMark team, I contribute to building a secure platform using React and AWS. InkMark leverages blockchain to lock in the date and ownership of your files, providing verifiable proof of authorship. This makes it ideal for safeguarding legal documents, time-sensitive files, creative works, and intellectual property.",
    skill: "React | AWS",
    link: "https://inkmark.io/",
  },
  {
    img: Miradom,
    title: "Miradom",
    body: "As a Full Stack Developer I contributed to a project focused on creating a user-friendly platform for renting apartments. The platform ensures safety through guest vetting and promotes host inclusivity",
    skill: "React | NodeJS | TailwindCSS | MUI",
    link: "https://miradom-frontend.onrender.com/",
  },
  {
    img: multiform,
    title: "Multi Step Form",
    body: "I improved user experience through a dynamic multi-step form,real-time validation, and responsive design. This polished solution enhances user engagement and interaction.",
    skill: "NextJS | TailwindCSS | HTML | CSS",
    link: "https://multiform-virid.vercel.app/",
  },
  {
    img: urlshortner,
    title: "Url Shortner",
    body: "I developed a URL shortener with a full-stack approach, showcasing proficiency in frontend, backend, and enhanced development practices.",
    skill: "NextJS | TailwindCSS | ExpressJS | TypeScript",
    link: "https://url-shortner-frontend-tm3b.vercel.app/",
  },
  {
    img: phoneflag,
    title: "Phone Flag",
    body: "I created a responsive landing page for Phoneflag, emphasizing features and benefits. Through reusable components and design consistency, the page adapts seamlessly. It effectively communicates Phoneflag's value proposition, showcasing my expertise in crafting engaging and user-friendly landing pages.",
    skill: "React | Chakra UI | HTML | CSS",
    link: "https://phonflag-frontend.vercel.app/",
  },
];
